import { ArpAccess, ArpMedia } from '@arpeggi/shared'
import { IArpMedia } from '../../arp-registry/ArpMedia'

export const arpIsTokenGated = (arp: ArpMedia | IArpMedia): boolean => {
  return arp?.access !== undefined && arp?.access !== ArpAccess.STANDARD
}
